module.exports = __webpack_public_path__ + "img/bg-1.2e2283cc.jpg";